function initBundleVariantSync() {
  document.querySelectorAll('variant-selects').forEach(bundleSection => {
    const selects = bundleSection.querySelectorAll('.product-form__input--dropdown select');

    if (selects.length > 1) {
      selects.forEach((select, i) => {
        select.addEventListener('change', e => {
         
          if (select.dataset.syncing === 'true') return;
          const selectedText = select.options[select.selectedIndex].text.trim();
          
          selects.forEach(otherSelect => {
            if (otherSelect === select) return;
            otherSelect.dataset.syncing = 'true'; // mark as syncing
            for (let option of otherSelect.options) {
              if (option.text.trim() === selectedText) {
                console.log('hello',option.value);
                otherSelect.value = option.value;
                otherSelect.dispatchEvent(new Event('change', { bubbles: true }));
                break;
              }
            }
            otherSelect.dataset.syncing = 'false';
          });
        });
      });
    }
    else{

    $(document).on('change', '.product-form__input--dropdown select', function(){
         var sold = $(this).find('option:selected').attr('sold');
        if(sold == "true")
        {
          $('.product__text').removeClass('hidden');
        }
        else
        {
          $('.product__text').addClass('hidden');
        }
      });
    }
  });
}

// Wait for bundle to load dynamically
const waitForBundle = setInterval(() => {
  const found = document.querySelectorAll('variant-selects .product-form__input--dropdown select').length;
  if (found > 0) {
    console.log('hello');
    clearInterval(waitForBundle);
    initBundleVariantSync();
  }
}, 500);
